// extracted by mini-css-extract-plugin
module.exports =  {"container":"_93444fe79c--container--NQ9LX","inner":"_93444fe79c--inner--gWJ0E","description-wrapper":"_93444fe79c--description-wrapper--JKs05"};